<template>
  <div class="blank-view">
    <div v-if="$slots.action" class="action">
      <slot name="action" />
    </div>
    <div id="black-main" :style="mainStyle" class="main">
      <div :class="extraClass" :style="bodyStyle" class="main-body">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BlankView',
  props: {
    extraClass: {
      type: String,
      default: ''
    },
    bodyStyle: {
      type: Object,
      default: () => ({
        padding: '0'
      })
    },
    mainStyle: {
      type: Object,
      default: () => ({})
    }
  }
}
</script>

<style lang="less" scoped>
.blank-view {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
}
.action {
  margin-bottom: 8px;
}
.main {
  // position: relative;
  width: 100%;
  height: 100%;
  background-color: #fff;
  // padding: 16px;
  overflow-y: hidden;
  // box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  border: 1px solid #d8d8d8;
  border-radius: 2px;
  overflow: hidden;
}
.main-body{
  overflow: auto;
  width: 100%;
  height: 100%;
}
</style>
